import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  sendReminder,
  getEmailEvents,
} from '../services/signaturesApi'
import type { EmailEventsResponse } from '../services/signaturesApi'

/**
 * Send a signing reminder (nudge) to a signer.
 * Rate-limited: max 1 per 24 hours per signature request.
 */
export function useSendReminder() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ signatureRequestId, actorId }: { signatureRequestId: string; actorId: string }) =>
      sendReminder(signatureRequestId, actorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] })
      queryClient.invalidateQueries({ queryKey: ['emailEvents'] })
    },
  })
}

/**
 * Fetch email delivery events for all signers on a document.
 * Only fetches when document is active (pending/partially_signed).
 */
export function useEmailEvents(koblinkId: string | undefined, actorId?: string) {
  return useQuery<EmailEventsResponse>({
    queryKey: ['emailEvents', koblinkId, actorId],
    queryFn: () => getEmailEvents(koblinkId!, actorId),
    enabled: !!koblinkId,
    // No polling — real-time updates via SSE (useDocumentListSSE)
    staleTime: 30_000,
  })
}
